import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getAccessToken, setUserSession } from './service/AuthService';

import './css/Login-Register.css';
import logoBold from './assets/icon_logo.png';
import { MateriaBasicTextField, MaterialPassword } from './MaterialComponents';


//TODO: move this to an environment variable
const loginrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/login';
const loadingSpinner = document.querySelector('.donut');


const PreLoad = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    //Learning Form Data (move it here)
    function handleUsernameState(newValue) {
        setUsername(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }

    const [message, setMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);


    const navigate = useNavigate()

    const registerHandler = () => {
        console.log('lets register woooo')
        navigate('/register');
    }

    const submitHandler = (event) => {
        event.preventDefault();
        if(username.trim() === '' || password.trim() === ''){
            setMessage('Both username and password are required');
            return;
        }
        setMessage(null)
        setMessage('Logging in...')
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            password: password
        }



        axios.post(loginrUrl, requestBody, requestConfig).then(response => {
            const { user } = response.data;
            const accessToken = response.data.accessToken ?? response.data.token;
            const refreshToken = response.data.refreshToken ?? response.data.refresh_token ?? '';
            if (!user || !accessToken) {
                setMessage('Invalid login response. Please try again.');
                return;
            }
            setUserSession(user, accessToken, refreshToken);
            console.log('login data response')
            console.log(user)
            console.log(user.onboardingComplete)
            //TODO: fix bug -- update always shows up
            if(!user.onboardingComplete){
                navigate('/onboarding-demo');
            }
            else{
                document.querySelector('.header').style.display = 'block'
                navigate('/daily-content'); 
            }
            
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    useEffect(() => {
        const header = document.querySelector('.header');
        if (header) {
            header.style.display = 'none';
        }
        if (loadingSpinner) {
            loadingSpinner.style.display = 'none'; // Example: Change the text color
        }
        const splashTimer = setTimeout(() => {
            const hasSession = !!getAccessToken();
            if (header && hasSession) {
                header.style.display = 'block';
            }
            navigate(hasSession ? '/daily-content' : '/login');
        }, 4000);

        return () => clearTimeout(splashTimer);
    }, []);

    return (
        <div style={{ marginLeft: '2rem', marginRight: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%'}}> 
            <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh', width: '100vw' }}>
                <img style={{ width: '70%', maxWidth: '150px'}} src={logoBold} alt="Example" />
            </div>

        </div>
    )
}


export default PreLoad;